class FFPolicyPage extends HTMLElement {
  connectedCallback() {
    this.navButtons = Array.from(this.querySelectorAll('.ff-policy-page__nav-btn'));
    this.groups = Array.from(this.querySelectorAll('.ff-policy-page__group'));

    if (!this.navButtons.length || !this.groups.length) return;

    this.navButtons.forEach((btn) => {
      btn.addEventListener('click', () => this.scrollToGroup(btn.dataset.target));
    });

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.setActiveNav(entry.target.id);
          });
        },
        { rootMargin: '-20% 0px -60% 0px', threshold: 0 }
      );
      this.groups.forEach((group) => this.observer.observe(group));
    } else {
      this.setActiveNav(this.groups[0].id);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  scrollToGroup(id) {
    const target = this.querySelector(`#${id}`);
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.setActiveNav(id);
  }

  setActiveNav(id) {
    this.navButtons.forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.target === id);
    });
  }
}

customElements.define('ff-policy-page', FFPolicyPage);
